export default __webpack_public_path__ + "004a356b0b6dae4c9f7b17df93658cea.png";